<template lang="pug">
  .root
    TheHeading(:caption="caption" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        h2 {{data.title}} от {{data.completion_date | date}}
        table.table.table-striped.table-bordered
          tr
            td Тип документа
            td
              span(v-if="data.document_type") {{document_type_text}}
              span(v-if="!data.document_type") —
          tr
            td Дата документа
            td
              span(v-if="data.completion_date") {{data.completion_date | date}}
              span(v-if="!data.completion_date") —
          tr
            td Медицинская организация
            td
              span(v-if="data.hospital_name") {{data.hospital_name}}
              span(v-if="!data.hospital_name") —
          tr
            td Медицинская информационная система
            td
              span(v-if="data.his") {{his_text}}
              span(v-if="!data.his") —
        table.table.table-striped.table-bordered
          tr
            td Название услуги из МИС
            td
              span(v-if="data.service && data.service.mo_name") {{data.service.mo_name}}
              span(v-if="!data.service") —
          tr
            td Код услуги по ОМС
            td
              span(v-if="data.service && data.service.oms_code") {{data.service.oms_code}}
              span(v-if="!data.service") —
          tr
            td Код услуги по справочнику МО
            td
              span(v-if="data.service && data.service.mo_code") {{data.service.mo_code}}
              span(v-if="!data.service") —
          tr
            td Услуга по справочнику Webiomed
            td
              span(v-if="data.service && data.service.name") {{data.service.name}}
              span(v-if="!data.service") —

        physicalExamination(v-if="data.document_type == 1" :data="data")
        laboratoryInvestigation(v-if="data.document_type == 2" :data="data")
        dischargeReport(v-if="data.document_type == 3" :data="data")
        prescription(v-if="data.document_type == 4" :data="data")
        instrumentalInvestigation(v-if="data.document_type == 5" :data="data")
        hospitalDischargeReport(v-if="data.document_type == 6" :data="data")
        examinationCard(v-if="data.document_type == 8" :data="data")
        examinationQuestionary(v-if="data.document_type == 9" :data="data")
        examinationQuestionaryForAdultVersion2(v-if="data.document_type == 10" :data="data")
        examinationQuestionaryForAgesVersion2(v-if="data.document_type == 11" :data="data")
        medicalExaminationForIntoxicationAct(v-if="data.document_type == 12" :data="data")
        emergencyCallCard(v-if="data.document_type == 13" :data="data")
        examinationQuestionaryForAdultVersion1(v-if="data.document_type == 14" :data="data")
        examinationQuestionaryForAgesVersion1(v-if="data.document_type == 15" :data="data")
        defalutDocument(v-if="data.document_type == 16" :data="data")
        examinationQuestionaryDisability(v-if="data.document_type == 17" :data="data")
        healthScreeningQuestionnaire(v-if="data.document_type == 18" :data="data")
        operation(v-if="data.document_type == 19" :data="data")
        dispensaryObservationCardForHypertension(v-if="data.document_type == 20" :data="data")
        basicDeathCertificate(v-if="data.document_type == 21" :data="data")
        deathCertificate(v-if="data.document_type == 22" :data="data")
        dispensaryObservationCardForHypertension(v-if="data.document_type == 23" :data="data")
        examinationQuestionaryForAdultVersion3(v-if="data.document_type == 24" :data="data")
        examinationQuestionaryForAgesVersion3(v-if="data.document_type == 25" :data="data")

</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import ButtonsPanel from '@/components/parts/ButtonsPanel'
import axios from 'axios'

export default {
  components: {
    examinationQuestionary: () => import('@/templates/documents/examinationQuestionary'),
    hospitalDischargeReport: () => import('@/templates/documents/hospitalDischargeReport'),
    laboratoryInvestigation: () => import('@/templates/documents/laboratoryInvestigation'),
    medicalExaminationForIntoxicationAct: () => import('@/templates/documents/medicalExaminationForIntoxicationAct'),
    instrumentalInvestigation: () => import('@/templates/documents/instrumentalInvestigation'),
    examinationQuestionaryForAdultVersion2: () => import('@/templates/documents/examinationQuestionaryForAdultVersion2'),
    examinationQuestionaryForAgesVersion2: () => import('@/templates/documents/examinationQuestionaryForAgesVersion2'),
    examinationQuestionaryForAgesVersion3: () => import('@/templates/documents/examinationQuestionaryForAgesVersion3'),
    examinationQuestionaryForAdultVersion3: () => import('@/templates/documents/examinationQuestionaryForAdultVersion3'),
    examinationQuestionaryForAdultVersion1: () => import('@/templates/documents/examinationQuestionaryForAdultVersion1'),
    examinationQuestionaryForAgesVersion1: () => import('@/templates/documents/examinationQuestionaryForAgesVersion1'),
    emergencyCallCard: () => import('@/templates/documents/emergencyCallCard'),
    examinationCard: () => import('@/templates/documents/examinationCard'),
    prescription: () => import('@/templates/documents/prescription'),
    physicalExamination: () => import('@/templates/documents/physicalExamination'),
    dischargeReport: () => import('@/templates/documents/dischargeReport'),
    defalutDocument: () => import('@/templates/documents/defalutDocument'),
    examinationQuestionaryDisability: () => import('@/templates/documents/examinationQuestionaryDisability'),
    healthScreeningQuestionnaire: () => import('@/templates/documents/healthScreeningQuestionnaire'),
    operation: () => import('@/templates/documents/operation'),
    dispensaryObservationCardForHypertension: () => import('@/templates/documents/dispensaryObservationCardForHypertension'),
    basicDeathCertificate: () => import('@/templates/documents/basicDeathCertificate'),
    deathCertificate: () => import('@/templates/documents/deathCertificate'),
    ButtonsPanel,
    TheHeading
  },
  data () {
    return {
      data: {},
      caption: null,
      breadcrumbs: [],
      his_text: '',
      document_type_text: ''
    }
  },
  created () {
    if (this.$route.params.doc_id) {
      axios.get('dhra/api/v2/webiomedmpi/documents/' + this.$route.params.doc_id + '/').then(values => {
        this.data = values.data
        this.caption = values.data.title
        document.title = values.data.title
      })
    }
    if (localStorage.getItem('TokenInit') === 'Token') {
      this.breadcrumbs = [
        {
          title: `Запрос № ${this.$route.params.id}`,
          state: 'AnalysisSummary',
          params: { id: this.$route.params.id }
        }
      ]
    } else {
      this.breadcrumbs = [
        {
          title: 'Аналитика',
          state: 'Analytics'
        },
        {
          title: 'Запросы',
          state: 'Requests'
        },
        {
          title: `Запрос № ${this.$route.params.id}`,
          state: 'RequestSummary',
          params: { id: this.$route.params.id }
        }
      ]
    }
  },
  beforeUpdate () {
    if (this.data.his) this.getHis(this.data.his)
    if (this.data.document_type) this.getDocumentType(this.data.document_type)
  },
  methods: {
    closeState () {
      this.$router.go(-1)
    },
    getDocumentType (id) {
      axios.get('dhra/api/v2/nsi/values/sys-document-types/' + id + '/').then(values => { this.document_type_text = values.data.name })
    },
    getHis (id) {
      axios.get('gate/api/v1/nsi/values/sys-his/' + id + '/').then(values => { this.his_text = values.data.name })
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
.container
  background: #f7f7f0
  display: flex
  color: #212121
  min-height: 100vh
.main_block
  margin: 80px auto 40px auto
  padding: 20px 45px 30px 25px
  background: white
  width: 1400px
  text-align: center
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)
</style>
